import { IHocKyDangKyActionTypes } from "../../action-types/category/IHocKyDangKyActions";
import { IHocKyDangKyReducer } from "../../reducer-model/category/IHocKyDangKyReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IHocKyDangKyReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hocKyDangKys: [],
};
export const hocKyDangKyReducer = (
  state: IHocKyDangKyReducer = iniState,
  action: IHocKyDangKyActionTypes
): IHocKyDangKyReducer => {
  switch (action.type) {
    case "HOC_KY_DANG_KY_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HOC_KY_DANG_KY_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hocKyDangKys: action.payload,
      };
    case "HOC_KY_DANG_KY_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };

    default:
      return state;
  }
};
